import React from "react";
import ParticipantCard from "./ParticipantCard";
import DriverEventsCard from "./DriverEventsCard";
import LogFlowTimeline from "./LogFlowTimeline";

const LogsInsightsRow = ({ booking, driverEvents, logs }) => {
  return (
    <section className="logs-insights-row" aria-label="Booking participants and timeline">
      <ParticipantCard
        title="Driver"
        subtitle="Assigned driver"
        person={booking?.driver}
        accentClass="logs-participant-card--driver"
      />
      <ParticipantCard
        title="Dispatcher"
        subtitle="Dispatch contact"
        person={booking?.dispatcher}
        accentClass="logs-participant-card--dispatcher"
      />
      <DriverEventsCard events={driverEvents} />
      <LogFlowTimeline logs={logs} variant="embedded" />
    </section>
  );
};

export default LogsInsightsRow;
